import { reactive } from 'vue'

import useToggle from '@nicolaudie-group/ng-ui-kit/composables/useToggle'

import useQueryToggle from '@/composables/useQueryToggle'

function useDialog({
  initial,
  onChange,
  query,
  immediate = false,
} = {}) {
  const {
    state,
    toggle,
    set,
    on,
    off,
  } = (
    query
      ? useQueryToggle(query, { initial, setter: onChange, immediate })
      : useToggle(initial, onChange)
  )

  const control = reactive({
    onClose: off,
    state,
  })

  return {
    state,
    toggle,
    set,
    open: on,
    close: off,
    control,
  }
}

export default useDialog
